/* eslint-disable prettier/prettier */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fetchConfig from "./Constants/fetch";
import fallbackEnglish from "./translations/english/global";


i18n
  .use(initReactI18next)
  .init({
    lng: "en",
    fallbackLng: fallbackEnglish, // Fallback language
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true, // Enable suspense
    },
  });


// Share one request between i18n initialization and language selectors.
let translationsPromise;

const fetchTranslations = () => {
  if (translationsPromise) return translationsPromise;

  translationsPromise = fetch(`${fetchConfig.prefix}/translation/get_translations`, {
    cache: process.env.NODE_ENV === 'development' ? 'no-store' : 'default',
  })
    .then(response => {
      if (!response.ok) throw new Error('Failed to fetch translations');
      return response.json();
    })
    .then(translationsData => {
      Object.keys(translationsData).forEach(language => {
        i18n.addResourceBundle(
          language,
          'translation',
          translationsData[language],
          true,
          true
        );
      });
      return translationsData;
    })
    .catch(error => {
      translationsPromise = null;
      console.error('Error fetching translations:', error);
      return undefined;
    });

  return translationsPromise;
};

// Call fetchTranslations to initially load translations
fetchTranslations();

export const getLanguages = async () => {
  const translationsData = await fetchTranslations();
  console.log('Translations data in getLanguages:', translationsData); // Debugging log
  const languages = translationsData ? Object.keys(translationsData) : [];
  console.log('Extracted languages:', languages); // Debugging log
  return languages;
};

// Function to change language dynamically
export const changeLanguage = (language) => {
  i18n.changeLanguage(language);
};

export default i18n;
